import React, { useState, useContext, useEffect } from 'react';
import {
  Paper,
  Text,
  QuantaFormik,
  QuantaForm,
  useResponsiveParams,
  MixedGridGroup,
  useQuantaFormikContext,
  Grid,
  QuantaToggle,
  Button,
  NotificationList,
  InputGrid,
  CountAnimation,
} from 'quanta-ui';
import
 { CALCULATE_PREMIUM,
   INTERMEDIARY_LIST ,
   AGE_LIMIT,
   DCA_AGE_LIMIT,
   DEP_AGE_LIMIT,
  TYRE_AGE_LIMIT,
  NCBPROTECT_AGE_LIMIT,
  TENYEAR_AGE_LIMIT,
  FETCH_ROLE,
  GET_DEPCOVER
} from '../../queries';
import { useFetchQuery } from 'quanta-flows';
import { QuantaConfigContext } from 'quanta-flows'; //changed from ConfigContext to QuantaConfigContext
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@apollo/client';
import {Loading} from 'quanta-flows/modules/layout';
import {
  faCalculator,
  faChevronRight,
  faExclamationCircle,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
import { GET_TWO_WHEELER_POLICY_VAR_DETAILS } from '../../queries';
import { ModalViewBreakupTW } from 'quanta-flows/modules/common/viewBreakUp';
import { useHistory } from 'react-router-dom';
import { updateBuyMotorPolicy } from 'quanta-flows/modules/proposal/motor/state';
import moment from 'moment';
// Parse is changed to CurrencyFormater
import { CurrencyFormater } from 'quanta-flows';
// import { TransactionComponent } from 'quanta-flows';

export default function CoversForm({
  tenureList,
  riskCovers,
  productCode,
  productName,
  motorQuote,
  lobCode,
  lobName,
  quoteNumber,
  selectedIntermediary,
  fieldUserList,
  characterLimitList,
  modify,
  showCalculatePremiumButtonIDV,
  setshowCalculatePremiumButtonIDV,
  updatedidvvalues,
  calcPremOnLoad,
  SetCalcPremOnLoad,
  idvValues,
  ...props
}) {
  const history = useHistory();
  let colSpan_for_mobile = 1;
  let colSpan_for_Desktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: colSpan_for_mobile,
    for_desktop: colSpan_for_Desktop,
  });
  let repeatCover = useResponsiveParams({
    for_mobile: colSpan_for_mobile,
    for_desktop: 2,
  });
  let screenSize = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });
    const { loading: loadingagelimit,
      error: erroragelimit,
      data: agelimitdata, } = useQuery(AGE_LIMIT, {
        fetchPolicy: 'cache-and-network',
        variables: {
          input: {
            productCode: 3121,
            domainType: 'Consumable Cover Age Limit',
          },
        },
        onCompleted: (data) => {
        },
      });
      const { loading: loadingDCAagelimit,
        error: errorDCAagelimit,
        data: DCAagelimitdata, } = useQuery(DCA_AGE_LIMIT, {
          fetchPolicy: 'cache-and-network',
          variables: {
            input: {
              productCode: 3121,
              domainType: 'DCACover Age Limit',
            },
          },
          onCompleted: (data) => {
          },
        });
        const { loading: loadingtyreagelimit,
          error: errortyreagelimit,
          data: tyrelimitdata, } = useQuery(TYRE_AGE_LIMIT, {
            fetchPolicy: 'cache-and-network',
            variables: {
              input: {
                productCode: 3121,
                domainType: 'TYRE Cover Age Limit',
              },
            },
            onCompleted: (data) => {
            },
          });
          const { loading: loadingNCBprotectlimit,
            error: errorNCBprotectlimit,
            data: NCBprotectlimitdata, } = useQuery(NCBPROTECT_AGE_LIMIT, {
              fetchPolicy: 'cache-and-network',
              variables: {
                input: {
                  productCode: 3121,
                  domainType: 'NCB Age Limit',
                },
              },
              onCompleted: (data) => {
             //   console.log("123",data)
              },
            });
            const { loading: loadingtenyearlimit,
              error: errortenyearlimit,
              data: tenyearlimitdata, } = useQuery(TENYEAR_AGE_LIMIT, {
                fetchPolicy: 'cache-and-network',
                variables: {
                  input: {
                    productCode: 3121,
                    domainType: 'TEN Age Limit',
                  },
                },
                onCompleted: (data) => {
                //  console.log("142data",tenyearlimitdata)
                },
              });
        const { loading: loadingDEPagelimit,
          error: errorDEPagelimit,
          data: DEPlimitdata, } = useQuery(DEP_AGE_LIMIT, {
            fetchPolicy: 'cache-and-network',
            variables: {
              input: {
                productCode: 3121,
                domainType: 'DEP Cover Age Limit',
              },
            },
            onCompleted: (data) => {
            },
          });
    if (loadingagelimit||loadingtyreagelimit||loadingDCAagelimit||loadingDEPagelimit||loadingNCBprotectlimit||
      loadingtenyearlimit) {
      return (
        <div className="min-h-full">
          <Loading customMessage={'Fetching  details'} />
        </div>
      );
    }
    const consumable_limit = agelimitdata?.getDomainData
    const tyre_limit=tyrelimitdata?.getDomainData
    const DEP_limit=DEPlimitdata?.getDomainData
    const NCB_limit = NCBprotectlimitdata?.getDomainData
    const DCA_limit = DCAagelimitdata?.getDomainData
    const TENYR_LIMIT = tenyearlimitdata?.getDomainData

  const MINOR_THRESHOLD_AGE = 18;
  const Numberlimit =10
  const validate = (values) => {
    let errors = {};
    // if (!values?.tenure) {
    //   errors.tenure = '* Required';
    // }
    errors.addOnCovers = {};
    riskCovers?.forEach((riskCover) => {
      riskCover?.covers?.forEach((cover) => {
        if (values['addOnCovers'][`${cover?.name}`].selected) {
          cover?.attributes
            ?.filter((attribute) => attribute?.showOnScreen)
            ?.forEach((attribute) => {
              if (
                !values[`addOnCovers`][`${cover?.name}`][
                `attributes`
                ][`${attribute?.name}`] 
                && attribute?.fieldType !== 'checkbox' 
                && attribute?.name !== 'Clutch_Prot_SI_display'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                if (
                  !(
                    values[`addOnCovers`][`${cover?.name}`][
                    `attributes`
                    ][
                    `${cover?.attributes
                      ?.filter(
                        (attribute) => attribute?.showOnScreen,
                      )
                      ?.find(
                        (attribute) =>
                          attribute?.displayName?.toLowerCase() ===
                          'nominee dob',
                      )?.name
                    }`
                    ] &&
                    moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(
                        values[`addOnCovers`][`${cover?.name}`][
                        `attributes`
                        ][
                        `${cover?.attributes
                          ?.filter(
                            (attribute) =>
                              attribute?.showOnScreen,
                          )
                          ?.find(
                            (attribute) =>
                              attribute?.displayName?.toLowerCase() ===
                              'nominee dob',
                          )?.name
                        }`
                        ],
                        'DD/MM/YYYY',
                      ),
                      'years',
                    ) >= MINOR_THRESHOLD_AGE &&
                    (attribute?.displayName?.toLowerCase() ===
                      'name of appointee' ||
                      attribute?.displayName?.toLowerCase() ===
                      'relationship of appointee')
                  )
                ) {
                  errors[`addOnCovers`][`${cover?.name}`][
                    `attributes`
                  ][`${attribute?.name}`] = '* Required';
                }
              }
              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'nominee name',
                  )?.name
                }`
                ] &&
                !isNaN(
                  parseInt(
                    characterLimitList?.find(
                      (characterLimit) =>
                        characterLimit?.code
                          ?.toString()
                          ?.trim()
                          ?.toLowerCase() === 'first name',
                    )?.value,
                  ),
                ) &&
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'nominee name',
                    )?.name
                  }`
                ]?.length >
                parseInt(
                  characterLimitList?.find(
                    (characterLimit) =>
                      characterLimit?.code
                        ?.toString()
                        ?.trim()
                        ?.toLowerCase() === 'first name',
                  )?.value,
                ) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'nominee name'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Nominee name cannot be greater than ${characterLimitList?.find(
                  (characterLimit) =>
                    characterLimit?.code
                      ?.toString()
                      ?.trim()
                      ?.toLowerCase() === 'first name',
                )?.value
                } characters`;
              }
	       if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName ===
                      'CNG/ LPG KIT(Rs)',
                  )?.name
                }`
                ] &&
                !isNaN(
                  parseInt(
                    Numberlimit,
                  ),
                ) &&
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName ===
                        'CNG/ LPG KIT(Rs)',
                    )?.name
                  }`
                ]?.length >
                parseInt(
                  Numberlimit,
                ) &&
                attribute?.displayName?.toString() ===
                'CNG/ LPG KIT(Rs)'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `*Cannot be greater than ${Numberlimit
                } characters`;
              }
                if(motorQuote?.vehicleIsOwnedBy==='Corporate'&&motorQuote?.productType?.toLowerCase()?.search('od') == -1){
              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName ===
                      'No. of Employees',
                  )?.name
                }`
                ] 
                >
                parseInt(
                 motorQuote?.seatingCapacity
                ) 
              ) 
              {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* No of persons cannot be greater than carrying capacity for IMT 29 cover`;
              }
            }
              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName ===
                      'Tyre Details(Serial No/Make/Year)',
                  )?.name
                }`
                ] &&
                !values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                ][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName ===
                        'Tyre Details(Serial No/Make/Year)',
                    )?.name
                  }`
                ]?.match(/^[a-zA-Z0-9\.\' ]*$/) &&
                attribute?.displayName?.toString() ===
                'Tyre Details(Serial No/Make/Year)'
              ) 
              {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Tyre Details can contain alphabets only`;
              }
              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'nominee name',
                  )?.name
                }`
                ] &&
                !isNaN(
                  parseInt(
                    characterLimitList?.find(
                      (characterLimit) =>
                        characterLimit?.code
                          ?.toString()
                          ?.trim()
                          ?.toLowerCase() === 'first name',
                    )?.value,
                  ),
                ) &&
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'nominee name',
                    )?.name
                  }`
                ]?.length >
                parseInt(
                  characterLimitList?.find(
                    (characterLimit) =>
                      characterLimit?.code
                        ?.toString()
                        ?.trim()
                        ?.toLowerCase() === 'first name',
                  )?.value,
                ) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'nominee name'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Nominee name cannot be greater than ${characterLimitList?.find(
                  (characterLimit) =>
                    characterLimit?.code
                      ?.toString()
                      ?.trim()
                      ?.toLowerCase() === 'first name',
                )?.value
                } characters`;
              }
              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'nominee name',
                  )?.name
                }`
                ] &&
                !values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                ][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'nominee name',
                    )?.name
                  }`
                ]?.match(/^[a-zA-Z ]+$/) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'nominee name'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Nominee name can contain alphabets only`;
              }

              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'name of appointee',
                  )?.name
                }`
                ] &&
                !isNaN(
                  parseInt(
                    characterLimitList?.find(
                      (characterLimit) =>
                        characterLimit?.code
                          ?.toString()
                          ?.trim()
                          ?.toLowerCase() === 'first name',
                    )?.value,
                  ),
                ) &&
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'name of appointee',
                    )?.name
                  }`
                ]?.length >
                parseInt(
                  characterLimitList?.find(
                    (characterLimit) =>
                      characterLimit?.code
                        ?.toString()
                        ?.trim()
                        ?.toLowerCase() === 'first name',
                  )?.value,
                ) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'name of appointee'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Appointee name cannot be greater than ${characterLimitList?.find(
                  (characterLimit) =>
                    characterLimit?.code
                      ?.toString()
                      ?.trim()
                      ?.toLowerCase() === 'first name',
                )?.value
                } characters`;
              }

              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'name of appointee',
                  )?.name
                }`
                ] &&
                !values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                ][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'name of appointee',
                    )?.name
                  }`
                ]?.match(/^[a-zA-Z ]+$/) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'name of appointee'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Appointee name can contain alphabets only`;
              }
              if(motorQuote?.businessType?.toLowerCase() == 'roll over'){
              if (
                attribute?.fieldType === 'checkbox' &&
                  values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                  ][`${attribute?.name}`]?.toString()==='false'
                
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = '* Required';
              }
            }
              if (
                attribute?.fieldDataType === 'amount' &&
                parseFloat(
                  values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                  ][`${attribute?.name}`],
                ) <= 0
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = '* Amount should be greater than 0';
              }else if (attribute?.fieldDataType === 'amount' &&
              parseFloat(
                values[`addOnCovers`][`${cover?.name}`][
                `attributes`
                ][`${attribute?.name}`],
              ) >= 0){
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
              }
                 //Non Electrical Accessories OD -  NonElectricAccessoriesIdvSI
                if((cover?.name?.toLowerCase()?.search('electronic accessories') !== -1 && 
                  attribute?.name === 'ElectricAccessoriesIdvSI' )
                  || (cover?.name?.toLowerCase()?.search('non electrical accessories') !== -1 
                        && (attribute?.name === 'NonElectricAccessoriesIdvSI' ||
                        attribute?.name === 'NonElectricAccessoriesIdv') )
                   ){ if(parseFloat(
                      values[`addOnCovers`][`${cover?.name}`][
                      `attributes`
                      ][`${attribute?.name}`],
                    ) > (0.25*parseFloat(motorQuote?.changedIDV)) ){
                      errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                        `${attribute?.name}`
                      ] = '* Amount should be less than 25% of IDV';
                    }
                }
              }
              if (
                attribute?.fieldDataType === 'date' &&
                moment(
                  values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                  ][`${attribute?.name}`],
                  'DD/MM/YYYY',
                ).isAfter(moment(new Date(), 'DD/MM/YYYY'))
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = '* Cannot accept future date';
              }
            });
          if (
            errors[`addOnCovers`][`${cover?.name}`] &&
            errors[`addOnCovers`][`${cover?.name}`][`attributes`] &&
            Object.keys(
              errors[`addOnCovers`][`${cover?.name}`][`attributes`],
            )?.length === 0
          ) {
            delete errors[`addOnCovers`][`${cover?.name}`];
          }
        }
      });
    });
   
    if (
      updatedidvvalues?.current?.adjustmentIRF2 &&
      parseFloat(updatedidvvalues?.current?.adjustmentIRF2) < -parseFloat(idvValues?.insuredDeclaredValue?.irf2PctMin)
    ) {
      errors.adjustmentIRF2 = `* IRF2 Basic OD can't be less than -${idvValues?.insuredDeclaredValue?.irf2PctMin}%`;
    }
    if (
      updatedidvvalues?.current?.adjustmentIRF2 &&
      parseFloat(updatedidvvalues?.current?.adjustmentIRF2) > parseFloat(idvValues?.insuredDeclaredValue?.irf2PctMax)
    ) {
      errors.adjustmentIRF2= `*  IRF2 Basic OD can't be more than ${idvValues?.insuredDeclaredValue?.irf2PctMax}%`;
      }
     
    return errors;
  };

  const CoversDetails = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [
      showCalculatePremiumButton,
      setShowCalculatePremiumButton,
    ] = useState(false);

    const fetchQuery = useFetchQuery();
    const { branding } = useContext(QuantaConfigContext);
    const [premiumData, setPremiumData] = useState(null);
    const [showViewBreakup, setShowViewBreakup] = useState(false);
    const [alerts, setAlerts] = useState([]);
    const [loadingPremium, setLoadingPremium] = useState(false);
    const [proceeding, setProceeding] = useState(false);
    const [tariffAddonCover, setTariffAddonCover] = useState([]);
    const [kgiAddonCover, setKgiAddonCover] = useState([]);
    const [AddiAddonCover, setAddiAddonCover] = useState([]);
    const [resultPremiumError, setResultPremiumError] =
      useState(false);
    // const [coverDisable, setcoverDisable] = useState(
    //   motorQuote?.addOnCovers?.['Depreciation Cover']?.selected
    //   ?true
    //   :false); 
    // const [ConcoverDisable, setconcoverDisable] = useState(motorQuote?.addOnCovers?.['Consumable Cover']?.selected
    // ?true
    // :false); 
    // const [coverRTIDisable, setRTIcoverDisable] = useState(motorQuote?.addOnCovers?.['Return to Invoice']?.selected
    // ?true
    // :false); 
    // const [coverEngineeDisable, setEngineecoverDisable] = useState(motorQuote?.addOnCovers?.['Engine Protect']?.selected
    // ?true
    // :false); 
    const [coverDisable, setcoverDisable]=useState(motorQuote?.coverDisable ?motorQuote?.coverDisable:false);
    const [ConcoverDisable, setconcoverDisable] = useState(motorQuote?.ConcoverDisable ?motorQuote?.ConcoverDisable:false);
    const [coverRTIDisable, setRTIcoverDisable] = useState(motorQuote?.coverRTIDisable ?motorQuote?.coverRTIDisable:false);
    const [coverEngineeDisable, setEngineecoverDisable] = useState(motorQuote?.coverEngineeDisable ?motorQuote?.coverEngineeDisable:false);
    const calculatePremiumVariables = (tenure, riskInput,motorQuote1) => {
      return {
        input: {
          productCode: motorQuote?.productCode
            ? motorQuote?.productCode
            : motorQuote?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
              && motorQuote?.productType?.toLowerCase()?.search('od') === -1
              ? '3121'
              : motorQuote?.productVariant?.toLowerCase()?.search('liability') !== -1
                ? '3176'
                : motorQuote?.productType?.toLowerCase()?.search('od') !== -1
                  ? '3151'
                  : productCode,
          productType: motorQuote?.productType,
          customerType:
            motorQuote?.vehicleOwnerTypeAndGender?.organisationType,
          gender: motorQuote?.vehicleOwnerTypeAndGender?.gender,
          businessType: motorQuote?.businessType,
          intermediary: {
            intermediaryCode:
              motorQuote?.intermediaryDetails?.code ||
              selectedIntermediary?.intermediaryCode
            ,
            locationCode:motorQuote?.intermediaryDetails?.location
                      ?motorQuote?.intermediaryDetails?.location
                       :selectedIntermediary?.branchOfficeCode,
            fieldUserCode:
              motorQuote?.intermediaryDetails?.fieldUserCode ||
              selectedIntermediary?.fieldUserCode
            ,
          },
          tenure,
          rto: {
            rtoAuthCode: motorQuote?.rtoAuthorityCode,
            rtoLocCode: motorQuote?.rtoLocationCode,
            rtoLocDesc: motorQuote?.rtoLocationDesc,
          },
          vehicle: {
            make: motorQuote?.make?.code,
            model: motorQuote?.model?.code,
            variant: motorQuote?.variant?.code,
            engineNumber: motorQuote?.engineNo,
            chasisNumber: motorQuote?.chasisNo,
            registrationNumber: motorQuote?.regNo?.toUpperCase(),
            manufactureYear: motorQuote?.yearOfManufacture,
            regPurchaseDate: motorQuote?.dateOfReg,
            fuelType: motorQuote?.fuelType,
            seatingCapacity: motorQuote?.seatingCapacity,
            cubicCapacity: motorQuote?.cubeCapacity,
          },
          firstYearIDV: parseFloat(motorQuote1?.changedIDV),
          irf1: motorQuote1?.adjustmentIRF,
          IRF2BasicOD:motorQuote1?.adjustmentIRF2,
          IRF2AddOn:motorQuote1?.IRF2comments,
          minSuggestedIDV:motorQuote1?.minSuggestedIDV,
          maxSuggestedIDV:motorQuote1?.maxSuggestedIDV,
          prevInsurance: {
            coverType:
              (motorQuote?.businessType?.toLowerCase() === 'roll over' 
               ||motorQuote?.businessType?.toLowerCase() === 'new business')
                ? motorQuote?.policyCoverType
                : '',
            policyTenure:
              (motorQuote?.businessType?.toLowerCase() === 'roll over' 
              ||motorQuote?.businessType?.toLowerCase() === 'new business')
                ? motorQuote?.policyTenure
                : '',
            insurerName:
              (motorQuote?.businessType?.toLowerCase() === 'roll over' 
              ||motorQuote?.businessType?.toLowerCase() === 'new business')
                ? motorQuote?.prevInsurance?.insurerName
                : '',
            policyNumber:
             ( motorQuote?.businessType?.toLowerCase() === 'roll over' 
             ||motorQuote?.businessType?.toLowerCase() === 'new business')
                ? motorQuote?.prevInsurance?.policyNumber
                : '',
            startDate:
              (motorQuote?.businessType?.toLowerCase() === 'roll over' 
              ||motorQuote?.businessType?.toLowerCase() === 'new business')
                ? motorQuote?.policyStartDate
                : '',
            expiryDate:
              (motorQuote?.businessType?.toLowerCase() === 'roll over' 
              ||motorQuote?.businessType?.toLowerCase() === 'new business')
                ? motorQuote?.policyExpiryDate
                : '',
            PypPolicyTenureTP: motorQuote?.TP_Policy_Tenure
            ? motorQuote?.TP_Policy_Tenure
            :'',
            PypStartDateTP: motorQuote?.TP_Start_Date
            ? motorQuote?.TP_Start_Date
            :'',
            PypEndDateTP: motorQuote?.TP_End_Date
            ? motorQuote?.TP_End_Date
            :'',
            PypInsurerTP:null,
            TPPolicyNo:null
          },
          prevClaims: {
            totalClaimCount:
              motorQuote?.businessType?.toLowerCase() === 'roll over' 
              ||motorQuote?.businessType?.toLowerCase() === 'new business'
                ? motorQuote?.totalClaimCount
                : '',
            claimsInYear1:
              motorQuote?.businessType?.toLowerCase() === 'roll over'
              ||motorQuote?.businessType?.toLowerCase() === 'new business'
                ? motorQuote?.noOfClaimsOneYear
                : '',
            claimsInYear2:
              motorQuote?.businessType?.toLowerCase() === 'roll over'
              ||motorQuote?.businessType?.toLowerCase() === 'new business'
                ? motorQuote.noOfClaimsTwoYears
                : '',
            claimsInYear3:
              motorQuote?.businessType?.toLowerCase() === 'roll over'
              ||motorQuote?.businessType?.toLowerCase() === 'new business'
                ? motorQuote.noOfClaimsThreeYears
                : '',
            prevNCBSlab:
              motorQuote?.businessType?.toLowerCase() === 'roll over'
              ||motorQuote?.businessType?.toLowerCase() === 'new business'
                ? motorQuote?.previousYearNCBSlab
                : '',
            totalClaimAmount:
              motorQuote?.businessType?.toLowerCase() === 'roll over'
              ||motorQuote?.businessType?.toLowerCase() === 'new business'
                ? parseFloat(motorQuote?.totalClaimAmount)
                : null,
            claimFreeYear: '',
          },
          financerName: motorQuote?.financerName,
          riskCovers: riskInput ? riskInput : [],
          creditScore: {
            discountOpted:
              motorQuote?.getAdditionalCreditScore?.toLowerCase() ===
                'yes'
                ? true
                : false,
            idProofType: motorQuote?.idProofType,
            idProofNumber: motorQuote?.idProofNumber,
            creditScore: motorQuote?.creditScore 
            ? parseFloat(motorQuote?.creditScore) 
            : null,
          },
          proposerPincode: motorQuote?.pincode,
          voluntaryDeductibleAmt:
            motorQuote?.voluntaryDeductibleAmount
              ? parseFloat(motorQuote?.voluntaryDeductibleAmount)
              : null,
        },
      };
    };

    useEffect(() => {
      const getCalculatePremium = async () => {
        updateMotorQuote({
          ...motorQuote,
          suggestedIDV:productCode?.toString()!=='3176'?updatedidvvalues?.current?.suggestedIDV:'0',
          changedIDV:productCode?.toString()!=='3176'?updatedidvvalues?.current?.changedIDV:'0',
          adjustmentIRF:updatedidvvalues?.current?.adjustmentIRF,
          adjustmentIRF2:updatedidvvalues?.current?.adjustmentIRF2?.toString(),
          IRF2comments:updatedidvvalues?.current?.IRF2comments,
          minSuggestedIDV:idvValues?.insuredDeclaredValue.minSuggestedIDV?.toString(),
          maxSuggestedIDV:idvValues?.insuredDeclaredValue.maxSuggestedIDV?.toString()
        })
        let adj  =  validate(values).adjustmentIRF2
         if(updatedidvvalues?.current?.errors>0 ||adj){
          setShowCalculatePremiumButton(true)
          setAlerts([
            {
              id: alerts?.length + 1,
              content: <Text>{ adj ? adj :
              'Please fill the mandatory fields before proceeding'}</Text>,
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
          
         }
         else if(motorQuote?.vehicleIsOwnedBy==='Corporate'&&motorQuote?.productType?.toLowerCase()?.search('od') == -1&&!values?.[`addOnCovers`]?.[`Legal Liability for Employees other than paid driver conductor cleaner`]?.selected){
          setShowCalculatePremiumButton(true)
          setAlerts([
            {
              id: alerts?.length + 1,
              content: <Text>IMT 29(Legal Liability for Employees other than paid driver conductor cleaner) is mandatory if customer type is organisation</Text>,
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          
         }
         else{
           if ((motorQuote?.quotationNo && !modify) || (modify && calcPremOnLoad)) {
          setPremiumData({
            calculatePremiumQuoteCarSecure: {
              ...motorQuote?.premiumData,
            },
          });
        } else {
          try {
            setResultPremiumError(false);
            let riskInput = [];
            riskCovers?.forEach((r) => {
              let covers = [];
              r.covers
                .filter(
                  (c) => values[`addOnCovers`][c?.name]?.selected,
                )
                .forEach((c) => {
                  const { selected, attributes, ...rest } = c;
                  let attributesArr = [];
                  c?.attributes?.forEach((attribute) => {
                    attributesArr.push({
                      ...attribute,
                      value: attribute?.showOnScreen
                        ? `${values[`addOnCovers`][`${c?.name}`][
                        `attributes`
                        ][`${attribute?.name}`]
                        }`
                        : `${attribute?.defaultValue}`,
                    });
                  });
                  covers.push({
                    ...rest,
                    attributes: [...attributesArr],
                  });
                });
              if (covers?.length !== 0) {
                riskInput.push({
                  riskType: r?.riskType,
                  covers,
                });
              }
            });
            const motorQuoteQuery = fetchQuery({
              query: GET_TWO_WHEELER_POLICY_VAR_DETAILS,
              fetchPolicy: 'network-only',

            });
            const { data: motorQuoteData } =
            await motorQuoteQuery;
            const { motorQuote } = motorQuoteData;
            let motorQuote1=motorQuote
            const calculatePremium = fetchQuery({
              query: CALCULATE_PREMIUM,
              fetchPolicy: 'network-only',
              variables: calculatePremiumVariables(
                values?.tenure,
                riskInput,
                 motorQuote1,
              ),
            });
            setFieldValue(`isPremiumLoading`, true);
            setAlerts([]);
            setLoadingPremium(true);
            let CoverList = {}
            riskCovers?.map((riskCover) => {
              return riskCover?.covers?.map(
                (cover) => (values[`addOnCovers`][cover?.name]?.selected
                  ? CoverList[cover?.name] = { selected: values[`addOnCovers`][cover?.name]?.selected } : null)
              )
            })?.filter((e) => e);
          
            updateMotorQuote({
              ...motorQuote,
              isPremiumCalculating: true,
              suggestedIDV:productCode?.toString()!=='3176'?updatedidvvalues?.current?.suggestedIDV:'0',
              changedIDV:productCode?.toString()!=='3176'?updatedidvvalues?.current?.changedIDV:'0',
              adjustmentIRF:updatedidvvalues?.current?.adjustmentIRF,
              adjustmentIRF2:updatedidvvalues?.current?.adjustmentIRF2?.toString(),
              IRF2comments:updatedidvvalues?.current?.IRF2comments,
               productCode:motorQuote?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
               ?'3121'
               :motorQuote?.productVariant?.toLowerCase()?.search('liability') !== -1
               ?'3176'
               :motorQuote?.productVariant?.toLowerCase()?.search('od') !== -1
               ?'3151'
               :'3121',
            addOnCovers:CoverList,
            coverData: {
                addOnCovers :riskCovers.map((riskCover, idx) => {
                  return {
                    riskType: riskCover?.riskType,
                    covers: riskCover?.covers?.map((cover) => {
                      

                      return {
                        name: cover?.name,
                        index: cover?.index,
                        selected: values[`addOnCovers`][cover?.name]?.selected,
                        disabled:
                        values[`addOnCovers`][cover?.name]?.disabled,
                       attributes:  
                      riskCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                          ?.covers?.find((cov) =>
                            (cov?.name === cover?.name )
                          )?.attributes?.map((e)=>{
                            return {
                              ...e,
                              value: values[`addOnCovers`][cover?.name]?.attributes[e?.name],
                            }
                          })
                            ,
                      }
                    })
                  }
                }),
              },
              coverDisable: coverDisable,
              ConcoverDisable: ConcoverDisable,
              coverRTIDisable: coverRTIDisable,
              coverEngineeDisable: coverEngineeDisable,
            });
            const { data: calculatePremiumData } =
              await calculatePremium;
            setLoadingPremium(false);
            setFieldValue(`isPremiumLoading`, false);
            setPremiumData(calculatePremiumData);
              /*SA CR_P3_311 - CLutch protection cover for PrivateCar */
              if(values?.addOnCovers?.["Clutch Protection"]?.selected?.toString() === 'true'){
                setFieldValue(
                  `addOnCovers.${`Clutch Protection`}.attributes.${`Clutch_Prot_SI_display`}`,
                  calculatePremiumData?.calculatePremiumQuoteCarSecure?.clutchProtSI
                );
              }
              /*EA CR_P3_311 - CLutch protection cover for PrivateCar */
            if (
              calculatePremiumData?.calculatePremiumQuoteCarSecure
                ?.warningMsg
            ) {
              setAlerts([
                {
                  id: alerts?.length + 1,
                  content: (
                    <div className="flex flex-row flex-wrap space-y-2 w-full h-full text-base">
                      <span>
                        {
                          calculatePremiumData
                            ?.calculatePremiumQuoteCarSecure?.warningMsg
                        }
                      </span>
                    </div>
                  ),
                  type: 'warning',
                  timeout: null,
                  disableClose: false,
                },
              ]);
            }
            updateMotorQuote({
              ...motorQuote,
              premiumData: {
                ...calculatePremiumData?.calculatePremiumQuoteCarSecure,
                tenure: values?.tenure,
              },
	      CalculatePremiumOnLoad: false,
              policy: {
                startDate: calculatePremiumData?.calculatePremiumQuoteCarSecure?.p_startdate,
                expiryDate: calculatePremiumData?.calculatePremiumQuoteCarSecure?.p_enddate,
                ncb: calculatePremiumData?.calculatePremiumQuoteCarSecure?.NCB
              },
	      suggestedIDV:productCode?.toString()!=='3176'?updatedidvvalues?.current?.suggestedIDV:'0',
              changedIDV:productCode?.toString()!=='3176'?updatedidvvalues?.current?.changedIDV:'0',
              adjustmentIRF:updatedidvvalues?.current?.adjustmentIRF,
              adjustmentIRF2:updatedidvvalues?.current?.adjustmentIRF2?.toString(),
              IRF2comments:updatedidvvalues?.current?.IRF2comments,
	        coverDisable: coverDisable,
                 ConcoverDisable: ConcoverDisable,
                 coverRTIDisable: coverRTIDisable,
                 coverEngineeDisable: coverEngineeDisable,
              isPremiumCalculating: false,
              addOnCovers:CoverList,
              coverData: {
                  addOnCovers :riskCovers.map((riskCover, idx) => {
                    return {
                      riskType: riskCover?.riskType,
                      covers: riskCover?.covers?.map((cover) => {
                        
  
                        return {
                          name: cover?.name,
                          index: cover?.index,
                          selected: values[`addOnCovers`][cover?.name]?.selected,
                          disabled:
                          values[`addOnCovers`][cover?.name]?.disabled,
                         attributes:  
                        riskCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                            ?.covers?.find((cov) =>
                              (cov?.name === cover?.name )
                            )?.attributes?.map((e)=>{
                              return {
                                ...e,
                                value: values[`addOnCovers`][cover?.name]?.attributes[e?.name],
                              }
                            })
                              ,
                        }
                      })
                    }
                  }),
                },
            });
          } catch (error) {
            setResultPremiumError(true);
            setFieldValue(`isPremiumLoading`, false);
            setLoadingPremium(false);
            let CoverList = {}
            riskCovers?.map((riskCover) => {
              return riskCover?.covers?.map(
                (cover) => (values[`addOnCovers`][cover?.name]?.selected
                  ? CoverList[cover?.name] = { selected: values[`addOnCovers`][cover?.name]?.selected } : null)
              )
            })?.filter((e) => e);
            
            updateMotorQuote({
              ...motorQuote,
              isPremiumCalculating: null,
              suggestedIDV:productCode?.toString()!=='3176'?updatedidvvalues?.current?.suggestedIDV:'0',
              changedIDV:productCode?.toString()!=='3176'?updatedidvvalues?.current?.changedIDV:'0',
              adjustmentIRF:updatedidvvalues?.current?.adjustmentIRF,
              adjustmentIRF2:updatedidvvalues?.current?.adjustmentIRF2?.toString(),
              IRF2comments:updatedidvvalues?.current?.IRF2comments,
              addOnCovers:CoverList,
              coverData: {
                addOnCovers :riskCovers.map((riskCover, idx) => {
                  return {
                    riskType: riskCover?.riskType,
                    covers: riskCover?.covers?.map((cover) => {
                    
                      return {
                        name: cover?.name,
                        index: cover?.index,
                        selected: values[`addOnCovers`][cover?.name]?.selected,
                        disabled:
                        values[`addOnCovers`][cover?.name]?.disabled,
                       attributes:  
                      riskCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                          ?.covers?.find((cov) =>
                            (cov?.name === cover?.name )
                          )?.attributes?.map((e)=>{
                            return {
                              ...e,
                              value: values[`addOnCovers`][cover?.name]?.attributes[e?.name],
                            }
                          })
                            ,
                      }
                    })
                  }
                }),
              },
            });
            //SA radhika
            if(error?.message){
            if(error.message.includes("Unexpected token")){
              error.message='Please try again after sometime'
            }
          }
          //EA radhika
            setAlerts([
              {
                header: 'Error calculating premium',
                id: alerts?.length + 1,
                content: (
                  <div className="flex flex-row flex-wrap space-y-2 w-full h-full text-base">
                    <span>{error?.message}</span>
                  </div>
                ),
                type: 'error',
                timeout: null,
                disableClose: false,
              },
            ]);
          }
        }
      }
      }

      if (!showCalculatePremiumButton||!showCalculatePremiumButtonIDV) {
        getCalculatePremium();
      }
    }, [showCalculatePremiumButton||showCalculatePremiumButtonIDV]);
    useEffect(() =>{
      if (motorQuote?.addOnCovers?.[`Unnamed Passengers Personal Accident`]
       && motorQuote?.addOnCovers?.[`Unnamed Passengers Personal Accident`]?.selected){
        setFieldValue(
          `addOnCovers.${`Unnamed Passengers Personal Accident`}.attributes.${`NoOfUnnamed`}`
            , motorQuote?.seatingCapacity);
       }
    },[motorQuote]);
    useEffect(() => {
      let KgiAddOn = [ 'N093891G0063', 'N093891G0111',  'N093891G0104',   'N093891G0045',  'N093891G0100', 'N093891G0099', 'N093891G0043', 'N093891G0101',  'N093891G0102', 'N093891G0090', 'N093891G0088', 'N093891G0087','N464403G0082','N464403G0087', 'N464403G0113','N464403G0100','N464403G0099','N464403G0043','N464403G0101', 'N464403G0102','N464403G0090','N464403G0088','N464403G0043','N464403G0103','N464403G0045','N464403G0084','N464403G0089','N093891G0112','N093891G0113','N093891G0114','N464403G0114','N464403G0115','N464403G0116'];
      let AdditionalAddOn =  ['N093891G0106' , 'N093891G0107' , 'N093891G0109' , 'N093891G0108' , 'N093891G0105' , 'N093891G0110' , 'N093891G0103','N464403G0108' ,'N464403G0107', 'N464403G0106','N464403G0105' ,'N464403G0104',
        'N093891G0115','N464403G0117'
      ];
      let TraiffAddOn = ['N093891G0089' ,'N093891G0084' ,'N093891G0058' ,'N093891G0095' ,'N093891G0094' ,'N093891G0093' ,'N093891G0051'];
      let kgiAddonCoverList =[];
      let tariffAddonCoverList =[];
      let AdditionalAddonCoverList =[];
       let coverInde = [] ;
       riskCovers?.map((riskCover, idx) =>{
        riskCover.covers.map((cover, idx) =>{
          coverInde.push(cover?.index);
          if(KgiAddOn?.find((e)=> e === cover?.index)){
            kgiAddonCoverList?.push(cover);
          }else if(AdditionalAddOn?.find((e)=> e === cover?.index)){
            AdditionalAddonCoverList?.push(cover);
          }else if(TraiffAddOn?.find((e)=> e === cover?.index)){
            tariffAddonCoverList?.push(cover);
          }
        })
       });
      setTariffAddonCover(tariffAddonCoverList);
      setKgiAddonCover(kgiAddonCoverList);
      setAddiAddonCover(AdditionalAddonCoverList);
    },[riskCovers]);
    const { loading: loadingRoleData, data: dataRole } = useQuery(
      FETCH_ROLE,
      {
        fetchPolicy: 'cache-first',
      },
    );

    const { loading: loadingdepcover,
      error: errordepcover,
      data: depcoverdata, } = useQuery(GET_DEPCOVER, {
        fetchPolicy: 'network-only',
        variables: {
            partnerid:(selectedIntermediary?.fieldUserCode)
           ? selectedIntermediary?.fieldUserCode
           : motorQuote?.intermediaryDetails?.code ||
            selectedIntermediary?.intermediaryCode
        },
        onCompleted: (data) => {
         
        },
      });
  
  const role = dataRole?.checkAuth?.role?.roleName;

    let premiumGridData = [
      {
        type: 'render',
        component: () => (
          <div className="flex flex-col space-y-1">
            <Text
              type="label"
              severity="info"
              className={showCalculatePremiumButton ? 'mb-0.5' : ''}
            >
              Annual Premium (inclusive of taxes)
            </Text>

            {(showCalculatePremiumButton ||showCalculatePremiumButtonIDV) &&(
              <Button
                flat={false}
                size={
                  screenSize?.toString()?.toLowerCase() === 'mobile'
                    ? 'small'
                    : 'medium'
                }
                className={
                  screenSize?.toString()?.toLowerCase() === 'mobile'
                    ? 'w-full'
                    : 'w-4/6'
                }
                disabled={
                  (validate(values)?.addOnCovers &&
                    Object.keys(validate(values)?.addOnCovers)
                      ?.length > 0) ||
                    (values?.isQuoteSaved && !modify) ||
                  values?.isQuoteSaving
                }
                iconPre={<FontAwesomeIcon icon={faCalculator} />}
                onClick={(_) => 
                  {
                    setShowCalculatePremiumButton(false)
                  setshowCalculatePremiumButtonIDV(false)
                  SetCalcPremOnLoad(false);
              
                  }}
              >
                Recalculate
              </Button>
            )}
            {(!showCalculatePremiumButton &&!showCalculatePremiumButtonIDV)&& (
              <Text
                severity="info"
                className="flex space-x-2 items-center"
              >
                {loadingPremium ? (
                  <>
                    <Text type="normal">
                      <FontAwesomeIcon icon={faSpinner} spin={true} />
                    </Text>
                    <Text>Calculating Premium</Text>
                  </>
                ) : resultPremiumError ? (
                  <>
                    <Text type="normal" severity="error">
                      <FontAwesomeIcon icon={faExclamationCircle} />
                    </Text>
                    <Text severity="error">
                      Error calculating premium
                    </Text>
                  </>
                ) : premiumData?.calculatePremiumQuoteCarSecure
                  ?.totalPremium ? (
                  <Text
                    severity="info"
                    type="larger"
                    className="flex space-x-2"
                  >
                    {/* <CountAnimation
                      end={
                        premiumData?.calculatePremiumQuoteCarSecure
                          ?.totalPremium
                      }
                      duration={1}
                      decimals={2}
                      prefix={branding.currency + ' '}
                      formattingFn={(num) => {
                        return Parse(
                          num,
                          true,
                          false,
                          branding,
                          true,
                        );
                      }}
                    /> */}
                    <Text severity="info" type="larger">
                      {CurrencyFormater(
                        premiumData?.calculatePremiumQuoteCarSecure
                          ?.totalPremium,
                        true,
                        false,
                        branding,
                        true,
                      )}
                    </Text>
                    <Text
                      type="label"
                      className="quanta_link cursor-pointer text-secondary h-full flex mt-0.5 flex-col justify-center items-center"
                      onClick={(_) => setShowViewBreakup(true)}
                    >
                      View Breakup
                    </Text>
                  </Text>
                ) : null}
              </Text>
            )}
          </div>
        ),
      },
      {
        type: 'render',
        colSpan: 1,
        className: 'flex flex-row justify-center items-center',
        component: () => (
          <div className="flex flex-col items-start justify-center h-full">
            {/* <TransactionComponent> */}
             {/* if Quote User === true hide button */}
              {role!=="Quote User"?<Button
                type="button"
                className={
                  screenSize?.toString()?.toLowerCase() === 'mobile'
                    ? 'w-full'
                    : 'w-48'
                }
                flat={false}
                size={
                  screenSize?.toString()?.toLowerCase() === 'mobile'
                    ? 'small'
                    : 'medium'
                }
                onClick={async (_) => {
                  try {
                    const motorQuoteQuery = fetchQuery({
                      query: GET_TWO_WHEELER_POLICY_VAR_DETAILS,
                    });
                    const intermediaryListQuery = fetchQuery({
                      query: INTERMEDIARY_LIST,
                    });
                    setProceeding(true);
                    const { data: motorQuoteData } =
                      await motorQuoteQuery;
                    const { data: intermediaryListData } =
                      await intermediaryListQuery;
                    setProceeding(false);
                    const { motorQuote } = motorQuoteData;
                    const { myIntermediaries } = intermediaryListData;
                    const getIntermediaryName = (code) => {
                      return myIntermediaries
                        ? myIntermediaries?.find(
                          (intermediary) =>
                            intermediary?.intermediaryCode === code,
                        )?.intermediaryName
                        : code;
                    };

                    const getBusinessLocation = (
                      intermediarycode,
                      locationCode,
                    ) => {
                      return myIntermediaries &&
                        intermediarycode &&
                        locationCode
                        ? myIntermediaries?.find(
                          (intermediary) =>
                            intermediary?.intermediaryCode ===
                            intermediarycode,
                        )
                          ? myIntermediaries
                            ?.find(
                              (intermediary) =>
                                intermediary?.intermediaryCode ===
                                intermediarycode,
                            )
                            ?.businessLocations.find(
                              (location) =>
                                location?.code === locationCode,
                            )?.name
                          : locationCode
                        : '';
                    };
                    updateBuyMotorPolicy({
                      businessType: motorQuote?.businessType,
                      businessTypeValue: motorQuote?.businessTypeValue,
                      productType: motorQuote?.productType,
                      productTypeValue: motorQuote?.productTypeValue,
                      productVariant: motorQuote?.productVariant,
                      productCode: motorQuote?.productCode,
                      disableNCB:motorQuote?.disableNCB ?true:false,
                      intermediaryDetails: {
                        code:
                          motorQuote?.intermediaryDetails?.code ||
                          selectedIntermediary?.intermediaryCode
                        ,
                        intermediaryName:
                          getIntermediaryName(
                            motorQuote?.intermediaryDetails?.code ||
                            selectedIntermediary?.intermediaryCode,
                          ) || selectedIntermediary?.intermediaryName,
                        location:
                          selectedIntermediary?.branchOfficeCode ||
                          motorQuote?.intermediaryDetails?.location,
                        branchOfficeName:
                          getBusinessLocation(
                            motorQuote?.intermediaryDetails?.code ||
                            selectedIntermediary?.intermediaryCode,
                            motorQuote?.intermediaryDetails?.location ||
                            selectedIntermediary?.branchOfficeCode,
                          ) || selectedIntermediary?.branchOfficeName,
                        fieldUserCode:
                          selectedIntermediary?.fieldUserCode ||
                          motorQuote?.intermediaryDetails
                            ?.fieldUserCode,
                        fieldUserName:
                          selectedIntermediary?.fieldUserName ||
                            motorQuote?.intermediaryDetails?.fieldUserName
                            ? selectedIntermediary?.fieldUserName ||
                            motorQuote?.intermediaryDetails
                              ?.fieldUserName
                            : selectedIntermediary?.fieldUserCode ||
                              motorQuote?.intermediaryDetails
                                ?.fieldUserCode
                              ? fieldUserList?.find(
                                (fieldUser) =>
                                  fieldUser?.fieldUserCode
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  (selectedIntermediary?.fieldUserCode ||
                                    motorQuote?.intermediaryDetails
                                      ?.fieldUserCode),
                              )?.fieldUserName
                              : '',
                      },
                      isQuoteSaved: motorQuote?.quotationNo
                        ? true
                        : false,
                      quoteData: motorQuote,
                      coverData: {
                        addOnCovers: values?.addOnCovers,
                        rawRiskData: riskCovers,
                        tenure: values?.tenure,
                      },
                      quoteNumber: motorQuote?.quotationNo,
                      quoteStatus: motorQuote?.quotationStatus,
                      quoteCreationDate: motorQuote?.quoteCreationDate,
                      proposerDetailsMeta: motorQuote?.customerMeta,
                      proposerDetails: motorQuote?.customer,
                      customerFetchRequiredOnLoad:
                        (motorQuote?.customer?.id !== ''
                        && motorQuote?.customer?.id !== null)
                        ? true : false,
                    });
                    /**SA Proposal Modify*/
                    if(motorQuote?.isProposalModify){
                      updateBuyMotorPolicy({
                        ...motorQuote?.proposalData,
                        vehicleTabDetails: {
                          vehicleRegistrationDetails : motorQuote?.proposalData?.vehicleTabDetails
                              ?.vehicleRegistrationDetails,
                          vehicleDetails : motorQuote?.proposalData?.vehicleTabDetails
                              ?.vehicleDetails,  
                          insuredDeclaredDetails:{
                            irfAdjustmentPercent: motorQuote?.adjustmentIRF,
                            vehicleIDV: motorQuote?.changedIDV,
                          }
                        },
                        isProposalModify: motorQuote?.isProposalModify,
                        proposalNumber:motorQuote?.proposalNumber,
                      })
                    }
                    /**EA Proposal Modify*/
                    history.push(
                      `/quote/motor/buy/${lobCode}/Car Insurance/${productCode}/${motorQuote?.productType}`,
                    );
                  } catch (error) {
                    setProceeding(false);
                    setAlerts([
                      ...alerts,
                      {
                        id: alerts?.length + 1,
                        content: <Text>Unable to proceed</Text>,
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                  }
                }}
                disabled={
                  loadingPremium ||
                  resultPremiumError ||
                  showCalculatePremiumButton ||
                  showCalculatePremiumButtonIDV || 
                  values?.isQuoteSaving ||
                  (motorQuote?.proposalNumber !== '' && !modify)  || /**Proposal Modify flag */
                  proceeding||!values?.isQuoteSaved
                }
                iconPost={
                  proceeding ? (
                    <FontAwesomeIcon icon={faSpinner} spin={true} />
                  ) : (
                    <FontAwesomeIcon icon={faChevronRight} />
                  )
                }
              >
                Proceed To Buy
             </Button>:""}
            {/* </TransactionComponent> */}
          </div>
        ),
      },
    ];

    const attributeData = (attributes, coverName) => {
      return attributes
        ? attributes
          .filter((attr) => attr.showOnScreen)
          .map((attribute) => {
            return attribute.fieldDataType === 'amount'
              ? {
                type: `${attribute.fieldType}`,
                label: (
                  <Text type={'label'}>
                    {attribute.displayName}{' '}
                    <Text severity="error">*</Text>
                  </Text>
                ),
                name: `addOnCovers.${coverName}.attributes.${attribute.name}`,
                disabled:
                  loadingPremium ||
                  //values?.isQuoteSaved ||
                  (values?.isQuoteSaved && !modify) || 
                  values?.isQuoteSaving ,
                className: `${loadingPremium ||
                  //values?.isQuoteSaved ||
                  (values?.isQuoteSaved && !modify) ||
                  values?.isQuoteSaving
                  ? 'border-neutral-dark'
                  : ''
                  }`,
                iconPre: (
                  <Text
                    severity={
                      loadingPremium ||
                       // values?.isQuoteSaved ||
                        (values?.isQuoteSaved && !modify) ||
                        values?.isQuoteSaving
                        ? 'neutral-darker'
                        : 'info'
                    }
                  >
                    {branding.currency}
                  </Text>
                ),
                data:
                  attribute.fieldType === 'select'
                    ? attribute.dataValues.map((dataval) => {
                      return {
                        label: dataval.value,
                        value: dataval.code,
                      };
                    })
                    : undefined,
                onDataChange: (val, _) => {
                  if (!showCalculatePremiumButton) {
                    setShowCalculatePremiumButton(true);
                  }
                  updateMotorQuote({
                    ...motorQuote,
                    isPremiumCalculating: null,
                  });
                },
              }
              : 
              ( 
               motorQuote?.businessType =='New Business'
               &&
               attribute?.name=='IsPrePolicyDepreciationCover'
              )?''

              :{
                type: `${attribute.fieldType}`,
                label: (
                  <Text type={'label'}>
                    {attribute.displayName}{' '}
                    <Text severity="error">*</Text>
                  </Text>
                ),
                name: `addOnCovers.${coverName}.attributes.${attribute.name}`,
                disabled:
                  ((attribute?.displayName?.toLowerCase() ===
                    'name of appointee' ||
                    attribute?.displayName?.toLowerCase() ===
                    'relationship of appointee') &&
                    moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(
                        values?.addOnCovers[`${coverName}`][
                        `attributes`
                        ][
                        `${attributes
                          .filter((attr) => attr.showOnScreen)
                          ?.find(
                            (attr) =>
                              attr?.displayName?.toLowerCase() ===
                              'nominee dob',
                          )?.name
                        }`
                        ],
                        'DD/MM/YYYY',
                      ),
                      'years',
                    ) >= MINOR_THRESHOLD_AGE) ||
                  loadingPremium ||
                 // values?.isQuoteSaved ||
                  (values?.isQuoteSaved && !modify) ||
                  values?.isQuoteSaving ||
                  attribute?.displayName === 'No. of passengers' ||
                  attribute?.displayName === 'No. of Paid Driver' ||
                  (attribute?.displayName === 'Number of Claims'&&
                  parseFloat(depcoverdata?.DepcoverFetch?.DepCvrClaims)==-1
                  )

                   ||
         
                  (attribute?.displayName ==='Owner Driver Tenure'&&
                  motorQuote?.businessType?.toLowerCase() === 'roll over')
                  || attribute.name === "Clutch_Prot_SI_display"  ,
                data:
                  attribute.fieldType === 'select'
                    ? attribute.dataValues.map((dataval) => {
                      return {
                        label: dataval.value,
                        value: dataval.code,
                      };
                    })
                    : undefined,
                onKeyDown: (evt) => {
                  if (
                    (attribute?.displayName
                      ?.toString()
                      ?.toLowerCase() === 'nominee name' ||
                      attribute?.displayName
                        ?.toString()
                        ?.toLowerCase() ===
                      'name of appointee') &&
                    (evt?.target?.value?.toString()?.length ===
                      0 ||
                      evt?.target?.value
                        ?.toString()
                        ?.endsWith(' ')) &&
                    evt.key === ' '
                  ) {
                    evt.preventDefault();
                  }
                },
                onDataChange: (val, _) => {
                  if (!showCalculatePremiumButton) {
                    setShowCalculatePremiumButton(true);
                    }
                    if ( attribute?.name === 'IsPrePolicyDepreciationCover'){
                      setFieldValue(
                        `addOnCovers.${coverName}.attributes.${attribute.name}`,
                        val?.toString() === 'true' ? 'true'
                        : 'false'
                      ); 
                  }
                  updateMotorQuote({
                    ...motorQuote,
                    isPremiumCalculating: null,
                  });
                  if (
                    attribute?.displayName?.toLowerCase() ===
                    'nominee dob' &&
                    moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(val, 'DD/MM/YYYY'),
                      'years',
                    ) >= MINOR_THRESHOLD_AGE
                  ) {
                    setFieldValue(
                      `addOnCovers.${coverName}.attributes.${attributes
                        .filter((attr) => attr.showOnScreen)
                        ?.find(
                          (attr) =>
                            attr?.displayName?.toLowerCase() ===
                            'name of appointee',
                        )?.name
                      }`,
                      '',
                    );
                    setFieldValue(
                      `addOnCovers.${coverName}.attributes.${attributes
                        .filter((attr) => attr.showOnScreen)
                        ?.find(
                          (attr) =>
                            attr?.displayName?.toLowerCase() ===
                            'relationship of appointee',
                        )?.name
                      }`,
                      '',
                    );
                  }
                },
              };
          })
        : [];
    };
    const other_props_attribute_form = {
      flow: 'cols',
      repeatCover,
      gapX: 8,
      gapY: 0.5,
      size: 'full',
    };

    const data = [
      {
        grid_type: 'data',
        grid_data: [
          {
            colSpan: colSpan_for_Desktop,
            text: (
              <>
                <InputGrid
                  data={premiumGridData}
                  repeat={repeat}
                  titleType="title"
                  gapX={6}
                  titleSeverity="info"
                />
                <div>
                  <NotificationList {...{ items: alerts }} />
                </div>
              </>
            ),
          },
        ],
      },
      // premiumData?.calculatePremiumQuoteCarSecure?.idv1 ||
      //   premiumData?.calculatePremiumQuoteCarSecure?.idv2 ||
      //   premiumData?.calculatePremiumQuoteCarSecure?.idv3
      //   ? {
      //     grid_type: 'data',
      //     grid_data: [
            // {
            //   label: 'Second Year Insured Declared Value(IDV)',
            //   text: /*(
            //     <CountAnimation
            //       end={parseFloat(
            //         premiumData?.calculatePremiumQuoteCarSecure?.idv2,
            //       )}
            //       duration={1}
            //       decimals={2}
            //       prefix={branding.currency + ' '}
            //       formattingFn={(num) => {
            //         return CurrencyFormater(num, true, false, branding, true);
            //       }}
            //     />
            //   )*/ `${CurrencyFormater(
            //     parseFloat(
            //       premiumData?.calculatePremiumQuoteCarSecure?.idv2,
            //     ),
            //     true,
            //     false,
            //     branding,
            //     true,
            //   )}`,
            // },
      //       // {
      //       //   label: 'Second Year Insured Declared Value(IDV)',
      //       //   text: /*(
      //       //     <CountAnimation
      //       //       end={parseFloat(
      //       //         premiumData?.calculatePremiumQuoteCarSecure?.idv2,
      //       //       )}
      //       //       duration={1}
      //       //       decimals={2}
      //       //       prefix={branding.currency + ' '}
      //       //       formattingFn={(num) => {
      //       //         return CurrencyFormater(num, true, false, branding, true);
      //       //       }}
      //       //     />
      //       //   )*/ `${CurrencyFormater(
      //       //     parseFloat(
      //       //       premiumData?.calculatePremiumQuoteCarSecure?.idv2,
      //       //     ),
      //       //     true,
      //       //     false,
      //       //     branding,
      //       //     true,
      //       //   )}`,
      //       // },
      //       // {
      //       //   label: 'Third Year Insured Declared Value(IDV)',
      //       //   text: /*(
      //       //     <CountAnimation
      //       //       end={parseFloat(
      //       //         premiumData?.calculatePremiumQuoteCarSecure?.idv3,
      //       //       )}
      //       //       duration={1}
      //       //       decimals={2}
      //       //       prefix={branding.currency + ' '}
      //       //       formattingFn={(num) => {
      //       //         return CurrencyFormater(num, true, false, branding, true);
      //       //       }}
      //       //     />
      //       //   )*/ `${CurrencyFormater(
      //       //     parseFloat(
      //       //       premiumData?.calculatePremiumQuoteCarSecure?.idv3,
      //       //     ),
      //       //     true,
      //       //     false,
      //       //     branding,
      //       //     true,
      //       //   )}`,
      //       // },
      //       //vehicle age hided
      //       // premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge !==
      //       //   null &&
      //       //   premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge !==
      //       //   undefined &&
      //       //   premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge !== ''
      //       //   ? {
      //       //     label: 'Vehicle Age',
      //       //     text: `${premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge} year(s)`,
      //       //   }
      //       //   : null,
      //     ].filter((d) => d),
      //   }
      //   : null,
      // {
      //   grid_type: 'data',
      //   grid_data: [
      //     {
      //       colSpan: colSpan_for_Desktop,
      //       text: (
      //         <div className="mt-2">
      //           <div>
      //             <Text severity="info">Add-on Covers</Text>
      //             <Grid repeat={1} className="mt-2">
      //               {riskCovers.map((riskCover, idx) => (
      //                 <Grid key={idx} repeat={1}>
      //                   {riskCover.covers.map((cover, idx) => (
      //                     <div key={idx}>
      //                       <QuantaToggle
      //                         label={cover?.name}
      //                         name={`addOnCovers.${cover?.name}.selected`}
      //                         disabled={
      //                           loadingPremium ||
      //                           values?.isQuoteSaved ||
      //                           values?.isQuoteSaving
      //                         }
      //                         onChange={(val) => {
      //                           setFieldValue(
      //                             `addOnCovers.${cover?.name}.selected`,
      //                             val,
      //                           );
      //                           if (!val) {
      //                             cover?.attributes?.forEach(
      //                               (attribute) => {
      //                                 setFieldValue(
      //                                   `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
      //                                   '',
      //                                 );
      //                               },
      //                             );
      //                           }
      //                           setShowCalculatePremiumButton(true);
      //                           updateMotorQuote({
      //                             ...motorQuote,
      //                             isPremiumCalculating: null,
      //                           });
      //                         }}
      //                       />
      //                       {values?.addOnCovers[`${cover?.name}`]
      //                         ?.selected && (
      //                         <InputGrid
      //                           {...{
      //                             data: attributeData(
      //                               cover?.attributes,
      //                               cover?.name,
      //                             ),
      //                             ...other_props_attribute_form,
      //                           }}
      //                         />
      //                       )}
      //                     </div>
      //                   ))}
      //                 </Grid>
      //               ))}
      //             </Grid>
      //           </div>
      //         </div>
      //       ),
      //     },
      //   ],
      // },
    ].filter((d) => d);

    const other_props = {
      flow: 'cols',
      textType: 'normal',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: false,
    };
    const updateAddOnGroupingLogic = (coverName,val) => {
    //cover validation for Depreciation Cover
     //    console.log("vallllllllll",val)
       if(coverName === 'Depreciation Cover'&&val==true){
       setFieldValue(
        `addOnCovers.${`Consumable Cover`}.selected`,
        true,
      );
      setFieldValue(
        `addOnCovers.${`Road Side Assistance`}.selected`,
        true,
      );
      setFieldValue(
        `addOnCovers.${`Loss of Personal Belongings`}.selected`,
        true,
      );
      setFieldValue(
        `addOnCovers.${`Key Replacement`}.selected`,
        true,
      );
      setcoverDisable(true)
       }
       if(coverName === 'Depreciation Cover'&&val==false){
        setFieldValue(
         `addOnCovers.${`Consumable Cover`}.selected`,
         false,
       );
       setFieldValue(
         `addOnCovers.${`Road Side Assistance`}.selected`,
         false,
       );
       setFieldValue(
         `addOnCovers.${`Loss of Personal Belongings`}.selected`,
         false,
       );
       setFieldValue(
         `addOnCovers.${`Key Replacement`}.selected`,
         false,
       );
       setFieldValue(
        `addOnCovers.${`Consumable Cover`}.disabled`,
        false,
      );
      setFieldValue(
        `addOnCovers.${`Road Side Assistance`}.disabled`,
         false,
       );
       setcoverDisable(false)
        }
       //cover validation for Return to invoice
       if(coverName === 'Return to Invoice'&&val==true){
        setFieldValue(
          `addOnCovers.${`Consumable Cover`}.selected`,
          true,
        );
        setFieldValue(
          `addOnCovers.${`Road Side Assistance`}.selected`,
          true,
        );
        setFieldValue(
          `addOnCovers.${`Loss of Personal Belongings`}.selected`,
          true,
        );
        setFieldValue(
          `addOnCovers.${`Key Replacement`}.selected`,
          true,
        );
        setFieldValue(
          `addOnCovers.${`Depreciation Cover`}.selected`,
          true,
        );
        setRTIcoverDisable(true)
        }
        if(coverName === 'Return to Invoice'&&val==false){
          setFieldValue(
            `addOnCovers.${`Consumable Cover`}.selected`,
            false,
          );
          setFieldValue(
            `addOnCovers.${`Road Side Assistance`}.selected`,
            false,
          );
          setFieldValue(
            `addOnCovers.${`Loss of Personal Belongings`}.selected`,
            false,
          );
          setFieldValue(
            `addOnCovers.${`Key Replacement`}.selected`,
            false,
          );
          setFieldValue(
            `addOnCovers.${`Depreciation Cover`}.selected`,
            false,
          );
          setFieldValue(
            `addOnCovers.${`Depreciation Cover`}.disabled`,
            false,
          );
          setFieldValue(
            `addOnCovers.${`Road Side Assistance`}.disabled`,
            false,
          );
          setFieldValue(
            `addOnCovers.${`Consumable Cover`}.disabled`,
            false,
          );
          setRTIcoverDisable(false)
          }
    //cover validation for Engine protect
    if(coverName === 'Engine Protect'&&val==true){
      setFieldValue(
        `addOnCovers.${`Consumable Cover`}.selected`,
        true,
      );
      setFieldValue(
        `addOnCovers.${`Road Side Assistance`}.selected`,
        true,
      );
      setFieldValue(
        `addOnCovers.${`Loss of Personal Belongings`}.selected`,
        true,
      );
      setFieldValue(
        `addOnCovers.${`Key Replacement`}.selected`,
        true,
      );
      setFieldValue(
        `addOnCovers.${`Depreciation Cover`}.selected`,
        true,
      );
      setEngineecoverDisable(true)
      }
      if(coverName === 'Engine Protect'&&val==false){
        setFieldValue(
          `addOnCovers.${`Consumable Cover`}.selected`,
          false,
        );
        setFieldValue(
          `addOnCovers.${`Road Side Assistance`}.selected`,
          false,
        );
        setFieldValue(
          `addOnCovers.${`Loss of Personal Belongings`}.selected`,
          false,
        );
        setFieldValue(
          `addOnCovers.${`Key Replacement`}.selected`,
          false,
        );
        setFieldValue(
          `addOnCovers.${`Depreciation Cover`}.selected`,
          false,
        );
        setEngineecoverDisable(false)
        setFieldValue(
          `addOnCovers.${`Depreciation Cover`}.disabled`,
          false,
        );
        setFieldValue(
          `addOnCovers.${`Road Side Assistance`}.disabled`,
          false,
        );
        setFieldValue(
          `addOnCovers.${`Consumable Cover`}.disabled`,
          false,
        );
        }
//cover validation for Consumable cover
if(coverName === 'Consumable Cover'&&val==true){
  setFieldValue(
    `addOnCovers.${`Road Side Assistance`}.selected`,
    true,
  );
  setFieldValue(
    `addOnCovers.${`Loss of Personal Belongings`}.selected`,
    true,
  );
  setFieldValue(
    `addOnCovers.${`Key Replacement`}.selected`,
    true,
  );
  setFieldValue(
    `addOnCovers.${`Depreciation Cover`}.selected`,
    true,
    setconcoverDisable(true)
  );
  }
  if(coverName === 'Consumable Cover'&&val==false){
    setFieldValue(
      `addOnCovers.${`Road Side Assistance`}.selected`,
      false,
    );
    setFieldValue(
      `addOnCovers.${`Loss of Personal Belongings`}.selected`,
      false,
    );
    setFieldValue(
      `addOnCovers.${`Key Replacement`}.selected`,
      false,
    );
    setFieldValue(
      `addOnCovers.${`Depreciation Cover`}.selected`,
      false,
    );
    setconcoverDisable(false);
    setFieldValue(
      `addOnCovers.${`Depreciation Cover`}.disabled`,
      false,
    );
    setFieldValue(
      `addOnCovers.${`Road Side Assistance`}.disabled`,
      false,
    );
    }
    }
    const data1 = [
      {
        title: 'Add-On Covers',
        grid_type: 'data',
        grid_data: [
          {
            colSpan: colSpan_for_Desktop,
            text: (
              <div className="mt-2">
                <div>
                  <Grid repeat={1} className="mt-8">
                    <Grid repeat={2}>
                        { kgiAddonCover?.map((cover, idx) => (
                          
                            <div key={idx}>
                              <QuantaToggle
                                label={cover?.name === 'CNG Kit TP' ? 'External CNG/LPG kit' : cover?.name } 
                                name={`addOnCovers.${cover?.name}.selected`}
                                // checked={}
                                disabled={
                                  cover?.disabled ||
                                  loadingPremium ||
                                  (values?.isQuoteSaved && !modify) ||
                                  values?.isQuoteSaving||
                                 
                                    (cover?.name === 'Return to Invoice'&& parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) > 4.5 ) 
				                                        
				                                          ||(cover?.name === 'Engine Protect'&&
                                       motorQuote?.productVariant?.toLowerCase()?.search('comprehensive') !==-1 &&
                                       (motorQuote?.fuelType=='Battery'||motorQuote?.fuelType=='Electric'
                                       ||motorQuote?.fuelType=='Electricity')  )
                                       ||(cover?.name === 'Engine Protect'&&
                                       motorQuote?.productVariant?.toLowerCase()?.search('od') !==-1 &&
                                       (motorQuote?.fuelType=='Battery'||motorQuote?.fuelType=='Electric'
                                       ||motorQuote?.fuelType=='Electricity')  )

                                    //  ||(cover?.name === 'Depreciation Cover')&&(parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(consumable_limit[0]?.code) ) 
                                    // ||(cover?.name === 'Consumable Cover')&&(parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(consumable_limit[0]?.code) )
                                    // ||(cover?.name === 'Engine Protect')&&(parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(consumable_limit[0]?.code) )
                                    // ||(cover?.name === 'NCB Protect')&&(parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(NCB_limit[0]?.code) )
                                    // ||(cover?.name === 'Loss of Personal Belongings')
                                    // &&(parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(NCB_limit[0]?.code) ) 
                                    // ||(cover?.name === 'Tyre Cover')&&(parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(tyre_limit[0]?.code) ) 
                                    ||  (cover?.name ==='Consumable Cover'&&coverDisable)
                                    ||(cover?.name === 'Road Side Assistance'&&coverDisable)
                                    ||(cover?.name === 'Depreciation Cover'&&ConcoverDisable)//DEPRECIATION COVER IS SELECTED AND DISABLED WHEN CONSUMABLE IS TRUE
                                    ||(cover?.name === 'Road Side Assistance'&&ConcoverDisable)// RSA IS SELECTED AND DISABLED WHEN CONSUMABLE IS TRUE
                                    ||(cover?.name === 'Depreciation Cover'&&coverRTIDisable)// DEP IS SELECTED AND DISABLED WHEN RTI IS TRUE
                                    ||(cover?.name === 'Consumable Cover'&&coverRTIDisable)// cons IS SELECTED AND DISABLED WHEN RTI IS TRUE
                                    ||(cover?.name === 'Road Side Assistance'&&coverRTIDisable)// RSA IS SELECTED AND DISABLED WHEN CONSUMABLE IS TRUE
                                    ||(cover?.name === 'Road Side Assistance'&&coverEngineeDisable)// RSA IS SELECTED AND DISABLED WHEN EP IS TRUE
                                    ||(cover?.name === 'Depreciation Cover'&&coverEngineeDisable)// DEP IS SELECTED AND DISABLED WHEN EP IS TRUE
                                    ||(cover?.name === 'Consumable Cover'&&coverEngineeDisable)// CON IS SELECTED AND DISABLED WHEN EP IS TRUE
                                    || values?.addOnCovers?.[cover?.name]?.disabled
                                    // more than ten year validation
                                    // ||(cover?.name === 'Additional PA Cover for Owner Driver')&&
                                    // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(TENYR_LIMIT[0]?.code) 
                                    // )
                                    // ||(cover?.name === 'Key Replacement')&&
                                    // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(TENYR_LIMIT[0]?.code) 
                                    // )
                                    // ||(cover?.name === 'Road Side Assistance')&&
                                    // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(TENYR_LIMIT[0]?.code) 
                                    // )
                                    

                                }
                                onChange={(val) => {
                                  setFieldValue(
                                    `addOnCovers.${cover?.name}.selected`,
                                    val,
                                  );
                                  if (!val) {
                                    cover?.attributes?.forEach(
                                      (attribute) => {
                                        if(cover?.name !== 'Depreciation Cover'&&
                                        cover?.name !== 'Key Replacement'&&
                                        cover?.name !== 'Loss of Personal Belongings'
                                        )  {
                                        setFieldValue(
                                          `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
                                          '',
                                        );
                                        }
                                      },
                                    );
                                  }
                                  updateAddOnGroupingLogic(cover?.name,val);
                                  setShowCalculatePremiumButton(true);
                                  updateMotorQuote({
                                    ...motorQuote,
                                    isPremiumCalculating: null,
                                  });
                                }}
                              />
                              {values?.addOnCovers[`${cover?.name}`]
                                ?.selected && (
                                  <InputGrid
                                    {...{
                                      data: attributeData(
                                        cover?.attributes,
                                        cover?.name,
                                      ),
                                      ...other_props_attribute_form,
                                    }}
                                  />
                                )}
                            </div> 
                        ))}
                      </Grid>
                  </Grid>
                </div>
              </div>
            ),
          },
        ],
      },
    ]
    const data2 = [
      {
        title: "Tariff's Add-on Covers",
        grid_type: 'data',
        grid_data: [
          {
            colSpan: colSpan_for_Desktop,
            text: (
              <div className="mt-2">
                <div>
                <Grid repeat={1} className="mt-8">
                    <Grid repeat={2}>
                        {tariffAddonCover?.map((cover, idx) => (
                            <div key={idx}>
                              <QuantaToggle
                                label={cover?.name=='Legal Liability for Employees other than paid driver conductor cleaner'?
                                'Legal Liability for Employees other than paid driver conductor cleaner (IMT 29)':cover?.name}
                                name={`addOnCovers.${cover?.name}.selected`}
                                disabled={
                                  loadingPremium ||
                                  (values?.isQuoteSaved && !modify)||
                                  values?.isQuoteSaving||
                                  motorQuote?.vehicleOwnerTypeAndGender?.organisationType=='Corporate'
                                  &&cover?.name=='Owner Driver'
                                }
                                onChange={(val) => {
                                  setFieldValue(
                                    `addOnCovers.${cover?.name}.selected`,
                                    val,
                                  );
                                  if (!val) {
                                    cover?.attributes?.forEach(
                                      (attribute) => {
                                        if(cover?.name !== 'Paid Driver PA Cover'&&cover?.name!=='Owner Driver' ) {
                                        setFieldValue(
                                          `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
                                          '',
                                        );
                                        }
                                      },
                                    );
                                  }else if(val){
                                    if(cover?.name === 'Unnamed Passengers Personal Accident'){
                                      setFieldValue(
                                        `addOnCovers.${cover?.name}.attributes[NoOfUnnamed]`,
                                        motorQuote?.seatingCapacity,
                                      );
                                    }
                                  }
                                  updateAddOnGroupingLogic(cover?.name,val);
                                  setShowCalculatePremiumButton(true);
                                  updateMotorQuote({
                                    ...motorQuote,
                                    isPremiumCalculating: null,
                                  });
                                }}
                              />
                              {values?.addOnCovers[`${cover?.name}`]
                                ?.selected && (
                                  <InputGrid
                                    {...{
                                      data: attributeData(
                                        cover?.attributes,
                                        cover?.name,
                                      ),
                                      ...other_props_attribute_form,
                                    }}
                                  />
                                )}
                            </div> 
                        ))}
                      </Grid>
                  </Grid>
                </div>
              </div>
            ),
          },
        ],
      },
    ]
    const data3 = [
      {
        title: "Additional Add-on Covers",
        grid_type: 'data',
        grid_data: [
          {
            colSpan: colSpan_for_Desktop,
            text: (
              <div className="mt-2">
                <div>
                <Grid repeat={1} className="mt-8">
                    <Grid repeat={2}>
                        {AddiAddonCover?.map((cover, idx) => (
                            <div key={idx}>
                              <QuantaToggle
                                label={cover?.name}
                                name={`addOnCovers.${cover?.name}.selected`}
                                disabled={
                                  loadingPremium ||
                                  (values?.isQuoteSaved && !modify) ||
                                  values?.isQuoteSaving
				  
                                  // ||(cover?.name === 'Daily Car Allowance')&&
                                  // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(DCA_limit[0]?.code) 
                                  // ) 
                                  // ||(cover?.name === 'Additional Towing Charges')&&
                                  // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(TENYR_LIMIT[0]?.code) 
                                  // )
                                  // ||(cover?.name === 'Courtesy Car Reimbursement')&&
                                  // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(TENYR_LIMIT[0]?.code) 
                                  // )
                                  // ||(cover?.name === 'Emergency Hotel and Taxi Expenses')&&
                                  // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(TENYR_LIMIT[0]?.code) 
                                  // )
                                  // ||(cover?.name === 'EMI Protect')&&
                                  // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(TENYR_LIMIT[0]?.code) 
                                  // )
                                  // ||(cover?.name === 'Hospital Cash Benefit')&&
                                  // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(TENYR_LIMIT[0]?.code) 
                                  // )
                                  // ||(cover?.name === 'Additional PA Cover for Passengers')&&
                                  // (parseFloat(premiumData?.calculatePremiumQuoteCarSecure?.vehicleAge) >parseFloat(TENYR_LIMIT[0]?.code) 
                                  // )
                                  || values?.addOnCovers?.[cover?.name]?.disabled
                                }
                                // checked={true}
                                onChange={(val) => {
                                  setFieldValue(
                                    `addOnCovers.${cover?.name}.selected`,
                                    val,
                                  );
                                  if (!val) {
                                    cover?.attributes?.forEach(
                                      (attribute) => {
                                        setFieldValue(
                                          `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
                                          '',
                                        );
                                      },
                                    );
                                  }
                                  setShowCalculatePremiumButton(true);
                                  updateMotorQuote({
                                    ...motorQuote,
                                    isPremiumCalculating: null,
                                  });
                                }}
                              />
                              {values?.addOnCovers[`${cover?.name}`]
                                ?.selected && (
                                  <InputGrid
                                    {...{
                                      data: attributeData(
                                        cover?.attributes,
                                        cover?.name,
                                      ),
                                      ...other_props_attribute_form,
                                    }}
                                  />
                                )}
                            </div> 
                        ))}
                      </Grid>
                  </Grid>
                </div>
              </div>
            ),
          },
        ],
      },
    ]
    const other_props1 = {
      flow: 'cols',
      textType: 'normal',
      repeat,
      gapX: 2,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true,
    };
    const other_props2 = {
      flow: 'cols',
      textType: 'normal',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true,
    };
    return (
      <>
        <Paper>
          <QuantaForm>

            <MixedGridGroup {...{ data: data1, ...other_props1 }} />
            <MixedGridGroup {...{ data: data2, ...other_props1 }} />
            <MixedGridGroup {...{ data: data3, ...other_props2 }} />
            <MixedGridGroup {...{ data, ...other_props }} />
            <div>
              <ModalViewBreakupTW
                {...{
                  showViewBreakup,
                  setShowViewBreakup,
                  productName,
                  productCode:productCode,
                  REACTIVE_VAR_QUERY:
                    GET_TWO_WHEELER_POLICY_VAR_DETAILS,
                  reactiveVarName: 'motorQuote',
                }}
              />
            </div>
          </QuantaForm>
        </Paper>
      </>
    );
  };
  const getInitialValues = () => {
    let initObj = {
      tenure: motorQuote?.businessType === 'New Business'
        ? '3'
        : '1',
      addOnCovers: {},
      adjustmentIRF2:updatedidvvalues?.current?.adjustmentIRF2
      ?updatedidvvalues?.current?.adjustmentIRF2
      :motorQuote?.adjustmentIRF2,
      rawRiskData:
        motorQuote?.coverData?.rawRiskData?.length > 0
          ? motorQuote?.coverData?.rawRiskData
          : riskCovers,
      isQuoteSaved: motorQuote?.quotationNo ? true : false,
      isQuoteSaving: false,
      isPremiumLoading: false,
    };
    if (
      motorQuote?.coverData?.addOnCovers &&
      motorQuote?.coverData?.addOnCovers?.length > 0
    ) {
      riskCovers?.forEach((riskCover) => {
        riskCover?.covers?.forEach((cover) => {

          initObj[`addOnCovers`][`${cover?.name}`] = {
            selected: (!motorQuote?.quotationNo
              && motorQuote.vehicleOwnerTypeAndGender.organisationType === 'Individual'
              && cover?.name === 'Owner Driver')
              ? true
              : motorQuote?.coverData?.addOnCovers
                ?.find(
                  (addOnCover) =>
                    addOnCover?.riskType?.toLowerCase() ===
                    riskCover?.riskType?.toLowerCase(),
                )
                ?.covers?.find(
                  (c) =>
                    c?.name?.toLowerCase() ===
                    cover?.name?.toLowerCase(),
                )
                ? motorQuote?.coverData?.addOnCovers?.find(
                  (addOnCover) =>
                    addOnCover?.riskType?.toLowerCase() ===
                    riskCover?.riskType?.toLowerCase(),
                )?.covers?.find((c) =>
                  c?.name?.toLowerCase() ===
                  cover?.name?.toLowerCase(), )?.selected !== undefined ?
                  motorQuote?.coverData?.addOnCovers?.find(
                    (addOnCover) =>
                      addOnCover?.riskType?.toLowerCase() ===
                      riskCover?.riskType?.toLowerCase(),
                                    )?.covers?.find((c) =>
                      c?.name?.toLowerCase() ===
                      cover?.name?.toLowerCase(), )?.selected : false
              : false,
            disabled:
              riskCovers?.find(
                  (addOnCover) =>
                    addOnCover?.riskType?.toLowerCase() ===
                    riskCover?.riskType?.toLowerCase(),
                )
                ?.covers?.find(
                  (c) =>
                    c?.name?.toLowerCase() ===
                    cover?.name?.toLowerCase(),
                )
                ? riskCovers?.find(
                  (addOnCover) =>
                    addOnCover?.riskType?.toLowerCase() ===
                    riskCover?.riskType?.toLowerCase(),
                )?.covers?.find((c) =>
                  c?.name?.toLowerCase() ===
                  cover?.name?.toLowerCase(),)?.disabled !== undefined ?
                  riskCovers?.find(
                    (addOnCover) =>
                      addOnCover?.riskType?.toLowerCase() ===
                      riskCover?.riskType?.toLowerCase(),
                  )?.covers?.find((c) =>
                    c?.name?.toLowerCase() ===
                    cover?.name?.toLowerCase(),)?.disabled : false
                : false,
            attributes: {},
          };
          cover?.attributes
            ?.filter((attribute) => attribute?.showOnScreen)
            .forEach((attribute) => {
              if(attribute?.name === 'NoOfUnnamed' ){
                initObj[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ]  =  motorQuote?.seatingCapacity;
              }else if ( attribute?.name === 'IsPrePolicyDepreciationCover'){
                initObj[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = motorQuote?.coverData?.addOnCovers
                  ?.find(
                    (addOnCover) =>
                      addOnCover?.riskType?.toLowerCase() ===
                      riskCover?.riskType?.toLowerCase(),
                  )
                  ?.covers?.find(
                    (c) =>
                      c?.name?.toLowerCase() ===
                      cover?.name?.toLowerCase(),
                  )
                  ?.attributes?.find(
                    (a) =>
                      a?.name?.toLowerCase() ===
                      attribute?.name?.toLowerCase(),
                  )?.value?.toString() === 'true' 
                    ? true
                    : false;
              }else{
              initObj[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${attribute?.name}`
              ] = motorQuote?.coverData?.addOnCovers
                ?.find(
                  (addOnCover) =>
                    addOnCover?.riskType?.toLowerCase() ===
                    riskCover?.riskType?.toLowerCase(),
                )
                ?.covers?.find(
                  (c) =>
                    c?.name?.toLowerCase() ===
                    cover?.name?.toLowerCase(),
                )
                ?.attributes?.find(
                  (a) =>
                    a?.name?.toLowerCase() ===
                    attribute?.name?.toLowerCase(),
                )?.value
                  ? motorQuote?.coverData?.addOnCovers
                    ?.find(
                      (addOnCover) =>
                        addOnCover?.riskType?.toLowerCase() ===
                        riskCover?.riskType?.toLowerCase(),
                    )
                    ?.covers?.find(
                      (c) =>
                        c?.name?.toLowerCase() ===
                        cover?.name?.toLowerCase(),
                    )
                    ?.attributes?.find(
                      (a) =>
                        a?.name?.toLowerCase() ===
                        attribute?.name?.toLowerCase(),
                    )?.value
                  : attribute?.value
                    ? attribute?.value
                    : attribute?.defaultValue
                      ? attribute?.defaultValue
                      : '';
                    }
            });
        });
      });
    } else {
      riskCovers?.forEach((riskCover) => {
        riskCover?.covers?.forEach((cover) => {
          initObj[`addOnCovers`][`${cover?.name}`] = {
            selected: ( !motorQuote?.quotationNo  && 
                motorQuote?.vehicleOwnerTypeAndGender
                ?.organisationType?.toString()?.toLowerCase() === 'individual'
                && cover?.name?.toString()?.toLowerCase() === 'owner driver')
                  ? true   
                  : cover?.selected 
                    ? cover?.selected 
                    : false,
            attributes: {},
            disabled: cover?.disabled ? cover?.disabled :false,
          };
          cover?.attributes
            ?.filter((attribute) => attribute?.showOnScreen)
            .forEach((attribute) => {
              initObj[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${attribute?.name}`
              ] = attribute?.value
                  ? attribute?.value
                  : attribute?.defaultValue
                    ? attribute?.defaultValue
                    : '';
            });
        });
      });
    }
    
    
    return initObj;
  };
  const initialValues = getInitialValues();
  return (
    <QuantaFormik
      innerRef={props?.forwardedCoversFormRef}
      {...{ initialValues, validate }}
    >
      <CoversDetails {...{ validate }} />
    </QuantaFormik>
  );
}
